/* ==========================================================================
   LAUZON — THE CATALOGUE product page: finish picker + purchase option.
   sections/lauzon-product-catalogue.liquid + snippets/lauzon-catalogue-picker.liquid

   Runs alongside lauzon-product.js, which still owns the gallery, the
   thumbnail rail, the lightbox and the sticky bar. This file never
   duplicates any of that: to show a finish's photo it CLICKS that photo's
   thumbnail, so the rail, the counter and the crossfade all behave exactly
   as they do when a visitor clicks it.

   What it does
   1. Finish picker. Reads the variant table the picker snippet prints
      (price, part number, photo, plan amounts — all formatted in Liquid, so
      the page and this script cannot disagree on money). Picking a value
      selects the matching variant, or the nearest one that has it.
   2. Purchase option. Pay in full disables the hidden `selling_plan` input
      (a disabled input never reaches /cart/add, which is the whole
      difference between the two paths) and shows Shopify's Shop Pay
      Installments banner; the deposit enables it and hides the banner,
      because a deposit cannot be financed.
   3. Upright photos (fallback). Photos are uploaded square; a Fender press
      shot that arrives unsquared (wide, file name `_rr` / `_rl`) is rotated
      in the frame by CSS via `.is-landscape` on the frame. lauzon-product.js swaps the <img> src
      when a thumbnail is chosen, so the class follows the src through a
      MutationObserver rather than through any coupling to that file.
   ========================================================================== */
(function () {
  'use strict';

  function init(root) {
    var box = root.querySelector('[data-cx-buybox]');
    if (!box || box.dataset.cxInit) return;
    box.dataset.cxInit = '1';

    var data = [];
    var dataEl = box.querySelector('[data-cx-variants]');
    try { data = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { data = []; }

    var idInput = box.querySelector('[data-cx-variant-id]');
    var planInput = box.querySelector('[data-cx-plan-input]');
    var opts = box.querySelector('[data-cx-opts]');
    var spiId = box.querySelector('[data-cx-spi-form] input[name="id"]');
    var picker = box.querySelector('[data-cx-picker]');
    var gal = document.querySelector('[data-cx-gal]');

    /* ---------- 3. Upright photos ---------- */
    if (gal && gal.hasAttribute('data-turn-upright')) {
      var mainImg = gal.querySelector('.gal-zoom img');
      var thumbs = Array.prototype.slice.call(document.querySelectorAll('.cx-thumbs .thumb[data-full]'));
      var syncOrientation = function () {
        if (!mainImg) return;
        var src = mainImg.getAttribute('src');
        var match = thumbs.filter(function (t) { return t.getAttribute('data-full') === src; })[0];
        if (match) {
          var turn = match.getAttribute('data-turn');
          gal.classList.toggle('is-landscape', turn === 'ccw' || turn === 'cw');
          gal.classList.toggle('is-cw', turn === 'cw');
        } else if (mainImg.naturalWidth) {
          var name = (src || '').split('?')[0].split('/').pop().toLowerCase();
          var wide = mainImg.naturalWidth > mainImg.naturalHeight;
          var rl = /_rl[._]/.test(name);
          gal.classList.toggle('is-landscape', wide && (rl || /_rr[._]/.test(name)));
          gal.classList.toggle('is-cw', wide && rl);
        }
      };
      if (mainImg && window.MutationObserver) {
        new MutationObserver(syncOrientation).observe(mainImg, { attributes: true, attributeFilter: ['src'] });
      }
    }

    /* ---------- 2. Purchase option ---------- */
    var current = null;

    function planFor(v) {
      if (!v || !planInput) return null;
      var want = planInput.getAttribute('data-plan-id') || planInput.value;
      for (var i = 0; i < v.plans.length; i++) {
        if (String(v.plans[i].id) === String(want)) return v.plans[i];
      }
      return v.plans[0] || null;
    }

    function choose(kind) {
      if (!opts) return;
      Array.prototype.forEach.call(opts.querySelectorAll('[data-cx-opt]'), function (label) {
        var on = label.getAttribute('data-cx-opt') === kind;
        label.classList.toggle('is-on', on);
        var radio = label.querySelector('input');
        if (radio) radio.checked = on;
      });
      if (planInput) planInput.disabled = kind !== 'plan';
    }

    if (opts && planInput) {
      planInput.setAttribute('data-plan-id', planInput.value);
      opts.addEventListener('change', function (event) {
        var label = event.target.closest('[data-cx-opt]');
        if (label) choose(label.getAttribute('data-cx-opt'));
      });
    }

    /* ---------- 1. Finish picker ---------- */
    if (!picker || !data.length || !idInput) return;

    var finishIndex = parseInt(picker.getAttribute('data-finish-index') || '0', 10);
    current = data.filter(function (v) { return String(v.id) === String(idInput.value); })[0] || data[0];
    var state = current.options.slice();

    function score(v) {
      var s = 0;
      for (var i = 0; i < state.length; i++) if (v.options[i] === state[i]) s++;
      return s;
    }

    function resolve(index, value) {
      state[index] = value;
      var exact = data.filter(function (v) { return v.options.join('\u0001') === state.join('\u0001'); })[0];
      if (exact) return exact;
      /* Nearest variant that HAS the value just picked, preferring one that
         keeps as many of the other choices as possible. */
      var cands = data.filter(function (v) { return v.options[index] === value; });
      cands.sort(function (a, b) { return score(b) - score(a); });
      return cands[0] || current;
    }

    function setText(sel, text) {
      Array.prototype.forEach.call(document.querySelectorAll(sel), function (el) { el.textContent = text; });
    }

    function apply(v, initial) {
      current = v;
      state = v.options.slice();

      idInput.value = v.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      /* The Shop Pay Installments banner under the price reads its own form. */
      if (spiId) {
        spiId.value = v.id;
        spiId.dispatchEvent(new Event('change', { bubbles: true }));
      }

      setText('[data-cx-price]', v.price_fmt);
      setText('[data-cx-sku]', v.sku || '');
      var skuWrap = box.querySelector('[data-cx-sku-wrap]');
      if (skuWrap) skuWrap.hidden = !v.sku;

      var name = picker.querySelector('[data-cx-finish-name]');
      if (name) name.textContent = v.options[finishIndex];
      Array.prototype.forEach.call(picker.querySelectorAll('[data-cx-opt-name]'), function (el) {
        el.textContent = v.options[parseInt(el.getAttribute('data-cx-opt-name'), 10)];
      });

      Array.prototype.forEach.call(picker.querySelectorAll('[data-option-index]'), function (btn) {
        var i = parseInt(btn.getAttribute('data-option-index'), 10);
        var val = btn.getAttribute('data-value');
        var on = v.options[i] === val;
        btn.classList.toggle('is-on', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        /* Availability BOTH ways (Dave S., 2026-10-05): a value no variant
           offers alongside the current other choices is drawn dashed. Still
           clickable; resolve() jumps to the nearest variant that has it.
           Same rule as snippets/lauzon-catalogue-pick-na.liquid. */
        var exists = data.some(function (d) {
          if (d.options[i] !== val) return false;
          for (var j = 0; j < d.options.length; j++) {
            if (j !== i && d.options[j] !== v.options[j]) return false;
          }
          return true;
        });
        btn.classList.toggle('is-na', !exists);
      });

      var plan = planFor(v);
      if (opts) {
        if (plan) {
          opts.hidden = false;
          planInput.value = plan.id;
          setText('[data-cx-deposit]', plan.deposit_fmt);
          setText('[data-cx-balance]', plan.balance_fmt);
          var planOn = opts.querySelector('[data-cx-opt="plan"]').classList.contains('is-on');
          choose(planOn ? 'plan' : 'full');
        } else {
          /* This finish has no plan attached (STOQ adds variants on its own
             schedule): pay in full is the only honest choice. */
          opts.hidden = true;
          planInput.disabled = true;
        }
      }

      if (v.media) {
        var thumb = document.querySelector('.cx-thumbs .thumb[data-media-id="' + v.media + '"]');
        if (thumb && thumb.getAttribute('aria-pressed') !== 'true') thumb.click();
      }

      if (!initial && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    picker.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-option-index]');
      if (!btn) return;
      var v = resolve(parseInt(btn.getAttribute('data-option-index'), 10), btn.getAttribute('data-value'));
      if (v) apply(v);
    });

    apply(current, true);
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
